export const CHUNK_PART_NAME = 'chunkFile';
export const CHUNK_INDEX_FIELD = 'chunk-index';
export const CHUNK_TOTAL_FIELD = 'total-chunk';
export const TOTAL_FILE_SIZE_FIELD = 'totalFileSize';

export interface AttachmentChunk {
  readonly index: number;
  readonly total: number;
  readonly blob: Blob;
  readonly fileName: string;
  readonly totalFileSize: number;
}

export function splitIntoChunks(file: File, chunkSize: number): AttachmentChunk[] {
  if (chunkSize < 1) {
    throw new Error('chunkSize must be at least 1 byte');
  }
  const total = Math.max(1, Math.ceil(file.size / chunkSize));
  const chunks: AttachmentChunk[] = [];
  for (let index = 0; index < total; index++) {
    const start = index * chunkSize;
    const end = Math.min(file.size, start + chunkSize);
    chunks.push({ index, total, blob: file.slice(start, end, file.type), fileName: file.name, totalFileSize: file.size });
  }
  return chunks;
}

export function chunkFormData(chunk: AttachmentChunk): FormData {
  const form = new FormData();
  form.append(CHUNK_PART_NAME, chunk.blob, chunk.fileName);
  form.append(CHUNK_INDEX_FIELD, chunk.index.toString());
  form.append(CHUNK_TOTAL_FIELD, chunk.total.toString());
  form.append(TOTAL_FILE_SIZE_FIELD, chunk.totalFileSize.toString());
  return form;
}

export const NOTE_ALREADY_EXISTS_ERROR = 'NoteAlreadyExists';
const HTTP_CONFLICT = 409;

export function isNoteAlreadyUploadedFailure(args: any): boolean {
  const request = args?.e?.currentTarget;
  return args?.response?.statusCode === HTTP_CONFLICT
    && typeof request?.responseText === 'string'
    && request.responseText.includes(`"${NOTE_ALREADY_EXISTS_ERROR}"`);
}

export function declaredFileSizeFormData(fileSize: number): { [TOTAL_FILE_SIZE_FIELD]: string } {
  return { [TOTAL_FILE_SIZE_FIELD]: fileSize.toString() };
}

export function uploadKeyOf(file: { id?: string; name: string }): string {
  return file.id || file.name;
}
